<template>
  <div class="flex flex-col-reverse md:flex-row">
    <span
      class="text-static-default-hi body-2-bold mr-4"
      data-qa="productCardPrice"
    >
      {{ price }}
    </span>

    <span v-if="priceNew" class="text-static-default-low body-2 line-through">
      {{ priceNew }}

      <span>
        {{ i18n(translations.newKeyword) }}
      </span>
    </span>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './PriceWithCrossedPrice.translations'

defineProps<{
  price: string
  priceNew?: string
}>()

const i18n = useI18n()
</script>
